// Values for all variables here should match with values in _variables.scss.

export const baseColors = {
  // official colors
  brandDark: 'rgb(0, 59, 92)',
  brandPrimary: 'rgb(220,88,42)',
  brandAccent: 'rgb(0, 156, 222)',
  nyanza: 'rgb(234, 252, 227)',

  // gray hues
  gray: 'rgb(140, 140, 140)',
  searchBorderGray: 'rgb(169, 169, 169)',
  silver: 'rgb(204, 204, 204)',
  actionBarBackground: 'rgb(238, 238, 238)',
  concrete: 'rgb(242, 242, 242)',
  whiteSmoke: 'rgb(249, 249, 249)',
  actionBarLines: 'rgb(89, 103, 120)'
}

export const colors = Object.assign(baseColors, {
  cardBackground: 'white',
  textGray: baseColors.gray,
  borderGray: baseColors.silver,
  backgroundGray: baseColors.whiteSmoke,
  tableRowStripedBackground: baseColors.concrete,
  searchBorderGray: baseColors.searchBorderGray,
  actionBarBackground: baseColors.actionBarBackground,
  actionBarLines: baseColors.actionBarLines,
  error: 'rgb(221, 90, 61)',
  info: 'rgb(9, 178, 231)',
  success: 'rgb(53, 187, 123)',
  warning: 'rgb(219,138,6)'
})

export const chartColors = [
  '#d55e00', '#0072b2', '#cc79a7', '#009e73', '#f0e442', '#911f12', '#56b4e9', '#e69f00', '#92e0b3', '#333333'
]

export const sizes = {
  pageHeaderHeight: '80px',
  buttonHeight: '32px',
  textInputHeight: '42px',
  formElementPadding: '16px',
  formElementMediumPadding: '10px',
  navHeight: '48px'
}

export const zIndexes = {
  layoutSidebar: 1,
  sideBySideChartFilterBar: 1,
  layoutContent: 2,
  sideBySideChartRight: 2,
  chartLoader: 3,
  editableBlockActionsArea: 3,
  sideBySideChartLeft: 3,
  scrollContent: 4,
  blockConfirmation: 4,
  pageHeader: 8,
  pageControlBar: 9,
  dropdownMenuOverlay: 10,
  inputMessageTooltip: 10,
  chartTooltip: 10,
  dropdownMenu: 11,
  executiveSummaryFullReportLink: 19,
  modalOverlay: 20,
  modal: 21,
  navbar: 40
}

export const fonts = {
  barlow: '"Barlow", san-serif',
  raleway: '"Raleway", sans-serif',
  lato: '"Lato", sans-serif'
}

export const boxShadows = {
  splitLayoutContent: `0 0 10px rgba(0, 0, 0, 0.1), 5px 5px 10px rgba(0, 0, 0, 0.1)`
}
